import fullpage from '../lib/fullpage/fullpage.extensions.min'

import { hideInfoSection } from './infoSection'
import businessBook from './businessBook'
import { initProjectItemsNavigation, scrollActiveDotIntoView } from './projectItem'

const loadedImageIndexes = []
const loadedVideoIndexes = []
const startedVideoIndexes = []
const savedVideoTimes = {}
let volumeListener
let currentSlide = 0
let userMuted = localStorage.getItem('userMuted') !== 'false'
let scrollHintObserver = null
let videoPreloadTimer = null
const isMobileVideoMode = window.matchMedia('(max-width: 767px)').matches || /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
const MOBILE_MIN_BUFFER_AHEAD = 2.0
let videoProgressWatchdog = null
let videoSectionActive = false
let infoExitInProgress = false
let nativeInfoScrollCleanup = []
let videoLoaderPositionRaf = null
const slideInfoTimers = {}
const isIOSVideoDevice = /iPhone|iPad|iPod/i.test(navigator.userAgent)

export const initFullPage = (page) => {
  const nativeInfoScrollPages = [
    'infographics',
    '_3d_animations',
    'virtual_tours',
    'virtual_reality'
  ]

  const useNativeInfoScroll = nativeInfoScrollPages.includes(page)

  console.log('init fullPage')

  listenToSectionButtonsClick()

  loadedImageIndexes.length = 0
  loadedVideoIndexes.length = 0
  startedVideoIndexes.length = 0
  Object.keys(savedVideoTimes).forEach(key => delete savedVideoTimes[key])

  // Fullpage doesn't allow initializing twice
  if (window.fullpage_api)
    window.fullpage_api.destroy('all')

  // noinspection JSPotentiallyInvalidConstructorUsage
  const fullPage = new fullpage('#fullpage', {
    scrollBar: false,
    scrollOverflow: !useNativeInfoScroll,
    scrolloverflowmacstyle: false,
    scrollOverflowReset: false,
    slideSelector: '.horizontal-scrolling',
    v2compatible: false,
    normalScrollElements: useNativeInfoScroll
      ? '#sidr, .selectable-container, .section.scroll'
      : '#sidr, .selectable-container',
    controlArrows: false,
    fadingEffect: 'slides',
    slidesNavigation: true,
    slidesNavPosition: 'bottom',
    navigationTooltips: ['firstSlide'],
    showActiveTooltip: true,
    loopHorizontal: true,
    menu: '#sidr',
    afterRender: function (_origin, destination, _direction) {
      const index = destination?.index
      const contentContainer =
        document.getElementById(index === undefined ? 'container-first-image' : `slide-index-${index}`)

      const isImage = !!contentContainer.dataset.image
      const isVideo = contentContainer.dataset.video === "true"
      videoSectionActive = isVideo

      if (!isVideo)
        hideVideoLoading(index)
      const isIframe = contentContainer.dataset.iframe === "true"
      const isQuotePage = page === 'quote'

      const isProjectItem =
        page === 'infographics' || page === 'virtual_reality' || page === 'virtual_tours' || page === '_3d_animations'

      if (isProjectItem) {
        initProjectItemsNavigation()
        arrangeTagButtons()
      }

      if (isImage)
        showImage(contentContainer, contentContainer, index)

      else if (isVideo) {
        const video = document.getElementById(`video-${index}`)
        currentSlide = index || 0
        showVideoLoading(currentSlide)
        if (startedVideoIndexes.includes(currentSlide))
          resumeVideoSafely(video, currentSlide)
        else
          startVideoSafely(video, currentSlide, true)

        showVolume(currentSlide, video)
        disableScroll()
      }

      else if (isIframe)
        disableScroll()

      if (isQuotePage) {
        const sideMenu = document.getElementById('side-menu')
        const logoContainer = document.getElementById('logo-container')

        sideMenu.style.color = '#222222'
        
        sideMenu.style.filter = 'none'
        logoContainer.classList.add('container-hidden')
      }

      showSlideInfo(index)
    },
    afterLoad: function (origin, destination, _direction) {    // sections ('up' and 'down')
      if (!fullPage)
        return

      const index = destination.index
      const contentContainer = document.getElementById(index === undefined ? 'container-first-image' : `slide-index-${index}`)

      const sideMenu = document.getElementById('side-menu')
      const logoContainer = document.getElementById('logo-container')
      const previousButton = document.getElementById('btn-previous')
      const nextButton = document.getElementById('btn-next')

      const isQuotePage = page === 'quote'
      const isContent = index === 0 && !isQuotePage
      const isInfoSection = index > 0 && !isQuotePage
      const isNativeInfoSection = useNativeInfoScroll && isInfoSection
      const isComingFromInfoSection = origin.index > 0 && !isQuotePage
      const isHomeBookSection = index === 1 && page === 'index'
      const isVideo = contentContainer && contentContainer.dataset.video === "true"

      if (isContent) {
        restoreVideosAfterIOSInfoSection()
        videoSectionActive = isVideo
        if (!videoSectionActive)
          hideVideoLoading(currentSlide)
        enableScroll()
        
      // En la primera sección, fullPage vuelve a controlar el desplazamiento vertical.
      fullPage.setAllowScrolling(true, 'up,down')

      document.body.classList.remove('info-scroll-active')
sideMenu.style.color = '#FFFFFF'
        
        sideMenu.style.filter = 'drop-shadow(1px 1px 0 rgba(0,0,0,0.9))'
        logoContainer.classList.remove('container-hidden')
        previousButton.classList.add('container-hidden')
        nextButton.classList.remove('container-hidden')

        if (isComingFromInfoSection && isVideo) {
          const video = document.getElementById(`video-${currentSlide}`)
          resumeVideoSafely(video, currentSlide)
        }
      }
      else if (isInfoSection) {
        videoSectionActive = false
        stopVideoProgressWatchdog()
        hideVideoLoading(currentSlide)
        hideVideosForIOSInfoSection()
        enableScroll()
        
      // Solo las páginas informativas largas (infografías, animaciones,
      // tours y VR) ceden el scroll vertical al navegador.
      // La segunda sección de HOME debe seguir controlada por fullPage
      // para que la rueda/touch permita volver a la primera sección.
      fullPage.setAllowScrolling(!isNativeInfoSection, 'up,down')

      if (isNativeInfoSection)
        document.body.classList.add('info-scroll-active')
      else
        document.body.classList.remove('info-scroll-active')
sideMenu.style.color = '#222222'
        
        sideMenu.style.filter = 'none'
        logoContainer.classList.add('container-hidden')
        previousButton.classList.remove('container-hidden')
        nextButton.classList.add('container-hidden')

        if (isHomeBookSection)
          businessBook.isPresent() && businessBook.animateContent()
        else {
          showInfoSection(index)
          showScrollHint()
        }
      }
    },
    afterSlideLoad: function (_section, _origin, destination, _direction) {
      const index = destination?.index
      currentSlide = index

      scrollActiveDotIntoView(index)

      const contentContainer = document.getElementById(index === undefined ? 'container-first-image' : `slide-index-${index}`)
      const isImage = !!contentContainer.dataset.image
      const isVideo = contentContainer.dataset.video === "true"
      videoSectionActive = isVideo

      if (!isVideo)
        hideVideoLoading(index)

      if (isImage) {
        const imageContainer = document.querySelector(`.image-${index}`)
        showImage(contentContainer, imageContainer, index)
      }
      else if (isVideo) {
        const video = document.getElementById(`video-${index}`)
        showVideoLoading(index)

        if (startedVideoIndexes.includes(index))
          resumeVideoSafely(video, index)
        else
          startVideoSafely(video, index, true)

        showVolume(index, video)
        showSlideInfo(index, 650)
      }
      else {
        // Iframes y otros contenidos: aparición rápida y consistente.
        showSlideInfo(index, 650)
      }
    },
    onSlideLeave (section, origin, destination) {
      removeVolumeListener()
      cancelVideoPreloadTimer()
      stopVideoProgressWatchdog()

      const originInfoIndex = origin?.index
      hideSlideInfo(originInfoIndex)

      const destinationIndex = destination?.index
      const destinationContainer = destinationIndex === undefined
        ? null
        : document.getElementById(`slide-index-${destinationIndex}`)

      videoSectionActive = destinationContainer?.dataset.video === 'true'

      if (videoSectionActive)
        showVideoLoading(destinationIndex)
      else
        hideVideoLoading(destinationIndex)

      const originIndex = origin?.index
      const video = document.getElementById(`video-${originIndex}`)

      if (video)
        unloadVideoSource(video, originIndex)
    },
    onLeave: function (origin, destination, _direction) {
      hideScrollHint()

      if (destination.index > 0) {
        videoSectionActive = false
        stopVideoProgressWatchdog()
      }

      hideVideoLoading(currentSlide)

      const isSection = document.getElementById(`info-section-${origin.index - 1}`)
      const isInfoSection = isSection && origin.index > 0

      if (isInfoSection)
        hideInfoSection(origin.index)
    },
  })

  window.fullpage_api = fullPage
  

  
function ensureNativeInfoScrollStyles() {
  if (document.getElementById('3ve-info-scroll-fix'))
    return

  const style = document.createElement('style')
  style.id = '3ve-info-scroll-fix'
  style.textContent = `
    .section.scroll {
      display: block !important;
      height: 100vh !important;
      max-height: 100vh !important;
      overflow-y: auto !important;
      overflow-x: hidden !important;
      box-sizing: border-box !important;
      -webkit-overflow-scrolling: touch;
      overscroll-behavior-y: contain;
    }
  `
  document.head.appendChild(style)
}

ensureNativeInfoScrollStyles()
setupNativeInfoScrollExit(fullPage)



function hideVideosForIOSInfoSection() {
  if (!isIOSVideoDevice)
    return

  document.querySelectorAll('video[id^="video-"]').forEach(video => {
    if (video.dataset.iosPreviousVisibility === undefined)
      video.dataset.iosPreviousVisibility = video.style.visibility || ''

    if (video.dataset.iosPreviousOpacity === undefined)
      video.dataset.iosPreviousOpacity = video.style.opacity || ''

    video.pause()
    video.style.visibility = 'hidden'
    video.style.opacity = '0'
    video.style.pointerEvents = 'none'
  })
}

function restoreVideosAfterIOSInfoSection() {
  if (!isIOSVideoDevice)
    return

  document.querySelectorAll('video[id^="video-"]').forEach(video => {
    video.style.visibility = video.dataset.iosPreviousVisibility || ''
    video.style.opacity = video.dataset.iosPreviousOpacity || ''
    video.style.pointerEvents = ''

    delete video.dataset.iosPreviousVisibility
    delete video.dataset.iosPreviousOpacity
  })
}

function setupNativeInfoScrollExit(fullPage) {
  nativeInfoScrollCleanup.forEach(cleanup => cleanup())
  nativeInfoScrollCleanup = []

  const sections = document.querySelectorAll('.section.scroll')

  sections.forEach(section => {
    let touchStartY = null

    const exitToContent = () => {
      if (infoExitInProgress)
        return

      infoExitInProgress = true

      restoreVideosAfterIOSInfoSection()
      fullPage.setAllowScrolling(true, 'up,down')
      fullPage.moveSectionUp()

      window.setTimeout(() => {
        infoExitInProgress = false
      }, 800)
    }

    const onWheel = event => {
      if (section.scrollTop <= 1 && event.deltaY < -2) {
        event.preventDefault()
        exitToContent()
      }
    }

    const onTouchStart = event => {
      touchStartY = event.touches && event.touches.length
        ? event.touches[0].clientY
        : null
    }

    const onTouchEnd = event => {
      if (touchStartY === null)
        return

      const touch = event.changedTouches && event.changedTouches.length
        ? event.changedTouches[0]
        : null

      if (!touch) {
        touchStartY = null
        return
      }

      const fingerMovedDown = touch.clientY - touchStartY

      if (section.scrollTop <= 1 && fingerMovedDown > 45)
        exitToContent()

      touchStartY = null
    }

    section.addEventListener('wheel', onWheel, { passive: false })
    section.addEventListener('touchstart', onTouchStart, { passive: true })
    section.addEventListener('touchend', onTouchEnd, { passive: true })

    nativeInfoScrollCleanup.push(() => {
      section.removeEventListener('wheel', onWheel)
      section.removeEventListener('touchstart', onTouchStart)
      section.removeEventListener('touchend', onTouchEnd)
    })
  })
}

function listenToSectionButtonsClick() {
    document.getElementById('btn-previous').onclick = () => fullPage.moveSectionUp()
    document.getElementById('btn-next').onclick = () => fullPage.moveSectionDown()
  }
}

function getBufferedAhead(video) {
  if (!video || !video.buffered || video.buffered.length === 0)
    return 0

  const t = video.currentTime

  for (let i = 0; i < video.buffered.length; i++) {
    const start = video.buffered.start(i)
    const end = video.buffered.end(i)

    if (t >= start && t <= end)
      return Math.max(0, end - t)
  }

  return 0
}

function stopVideoProgressWatchdog() {
  if (videoProgressWatchdog) {
    clearInterval(videoProgressWatchdog)
    videoProgressWatchdog = null
  }
}

function startVideoProgressWatchdog(video, index) {
  stopVideoProgressWatchdog()

  let lastTime = video.currentTime
  let stagnantChecks = 0

  videoProgressWatchdog = setInterval(() => {
    if (currentSlide !== index || !video || video.paused || video.ended) {
      stagnantChecks = 0
      lastTime = video ? video.currentTime : 0
      return
    }

    const now = video.currentTime
    const progressed = now > lastTime + 0.08

    if (progressed) {
      stagnantChecks = 0
      lastTime = now
      hideVideoLoading(index)
      return
    }

    stagnantChecks += 1

    // If the video has not advanced for ~1 second while it is supposed to
    // be playing, treat it as buffering even if Safari did not emit waiting.
    if (stagnantChecks >= 2)
      showVideoLoading(index)
  }, 500)
}

async function waitForBufferedAhead(video, index, minSeconds) {
  if (!isMobileVideoMode)
    return

  const startedAt = Date.now()

  while (currentSlide === index && !video.ended) {
    if (getBufferedAhead(video) >= minSeconds)
      return

    showVideoLoading(index)

    // Do not block forever on very slow networks. After a few seconds let
    // Safari try playback and let waiting/stalled events take over.
    if (Date.now() - startedAt > 6000)
      return

    await new Promise(resolve => setTimeout(resolve, 250))
  }
}

function getVideoLoadingIndicator() {
  return document.getElementById('video-global-loading')
}

function syncVideoLoaderToSite() {
  const loader = getVideoLoadingIndicator()
  const site = document.getElementById('fullpage')

  if (!loader || !site)
    return

  // Sidr desplaza la web al abrir el menú, pero un elemento position:fixed
  // puede quedarse anclado al viewport. Tomamos el desplazamiento real del
  // contenedor principal para que los tres puntos viajen exactamente con la web.
  const siteLeft = site.getBoundingClientRect().left
  loader.style.transform = `translate3d(${Math.round(siteLeft)}px, 0, 0)`
}

function startVideoLoaderPositionSync() {
  if (videoLoaderPositionRaf)
    return

  const tick = () => {
    const loader = getVideoLoadingIndicator()

    if (!loader || loader.style.display === 'none') {
      videoLoaderPositionRaf = null
      return
    }

    syncVideoLoaderToSite()
    videoLoaderPositionRaf = requestAnimationFrame(tick)
  }

  syncVideoLoaderToSite()
  videoLoaderPositionRaf = requestAnimationFrame(tick)
}

function stopVideoLoaderPositionSync() {
  if (videoLoaderPositionRaf) {
    cancelAnimationFrame(videoLoaderPositionRaf)
    videoLoaderPositionRaf = null
  }
}

function showVideoLoading(_index) {
  const loader = getVideoLoadingIndicator()

  if (!loader || !videoSectionActive)
    return

  syncVideoLoaderToSite()
  loader.style.display = 'block'
  loader.setAttribute('aria-hidden', 'false')
  startVideoLoaderPositionSync()
}

function hideVideoLoading(_index) {
  const loader = getVideoLoadingIndicator()

  if (!loader)
    return

  loader.style.display = 'none'
  loader.setAttribute('aria-hidden', 'true')
  loader.style.transform = ''
  stopVideoLoaderPositionSync()
}

function bindVideoLoadingState(video, index) {
  if (!video || video.dataset.loadingStateBound === 'true')
    return

  video.dataset.loadingStateBound = 'true'

  const showIfActive = () => {
    if (currentSlide === index)
      showVideoLoading(index)
  }

  const hideIfActuallyPlaying = () => {
    if (currentSlide !== index)
      return

    if (!video.paused && video.readyState >= HTMLMediaElement.HAVE_FUTURE_DATA)
      hideVideoLoading(index)
  }

  // Safari does not always emit the same sequence of events. Listen to all
  // relevant buffering signals and rely on the watchdog as a fallback.
  video.addEventListener('loadstart', showIfActive)
  video.addEventListener('waiting', showIfActive)
  video.addEventListener('stalled', showIfActive)
  video.addEventListener('seeking', showIfActive)
  video.addEventListener('suspend', () => {
    if (currentSlide === index && getBufferedAhead(video) < 0.5)
      showVideoLoading(index)
  })

  video.addEventListener('playing', () => {
    if (currentSlide === index) {
      hideVideoLoading(index)
      startVideoProgressWatchdog(video, index)
    }
  })

  video.addEventListener('canplay', hideIfActuallyPlaying)
  video.addEventListener('seeked', hideIfActuallyPlaying)

  video.addEventListener('pause', () => {
    if (currentSlide === index && !video.ended)
      showVideoLoading(index)
  })

  video.addEventListener('ended', () => {
    if (currentSlide === index)
      hideVideoLoading(index)
  })

  video.addEventListener('error', () => {
    if (currentSlide === index)
      hideVideoLoading(index)
  })
}

function ensureVideoSource(video, index) {
  if (!video)
    return false

  bindVideoLoadingState(video, index)

  const source = video.dataset.source
  if (!source)
    return false

  const hasSource = !!video.getAttribute('src')

  if (!hasSource) {
    video.src = source
    video.preload = 'auto'

    if (!loadedVideoIndexes.includes(index))
      loadedVideoIndexes.push(index)

    video.load()
  }
  else if (!loadedVideoIndexes.includes(index)) {
    loadedVideoIndexes.push(index)
  }

  return true
}

function waitForVideoEvent(video, eventName, readyTest) {
  return new Promise((resolve, reject) => {
    if (readyTest())
      return resolve()

    const onReady = () => {
      cleanup()
      resolve()
    }

    const onError = () => {
      cleanup()
      reject(video.error || new Error(`Video error while waiting for ${eventName}`))
    }

    const cleanup = () => {
      video.removeEventListener(eventName, onReady)
      video.removeEventListener('error', onError)
    }

    video.addEventListener(eventName, onReady, { once: true })
    video.addEventListener('error', onError, { once: true })
  })
}

async function prepareVideoAtStart(video, index) {
  if (!ensureVideoSource(video, index))
    return false

  video.autoplay = false
  video.removeAttribute('autoplay')
  video.muted = userMuted
  video.playsInline = true
  video.pause()

  try {
    await waitForVideoEvent(
      video,
      'loadedmetadata',
      () => video.readyState >= HTMLMediaElement.HAVE_METADATA
    )

    // Reset only after metadata is available. On some mobile browsers assigning
    // currentTime before this point is ignored or throws.
    if (Math.abs(video.currentTime) > 0.05)
      video.currentTime = 0
    else
      video.currentTime = 0

    await waitForVideoEvent(
      video,
      'loadeddata',
      () => video.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA
    )

    await waitForVideoEvent(
      video,
      'canplay',
      () => video.readyState >= HTMLMediaElement.HAVE_FUTURE_DATA
    )

    return true
  }
  catch (error) {
    console.warn('3VE: no se pudo preparar el vídeo', index, error)
    return false
  }
}

async function startVideoSafely(video, index, restartFromBeginning = true) {
  if (!video)
    return

  cancelVideoPreloadTimer()
  stopAllOtherVideoLoads(index)
  showVideoLoading(index)

  let ready = true

  if (restartFromBeginning) {
    delete savedVideoTimes[index]
    ready = await prepareVideoAtStart(video, index)
  }
  else {
    ensureVideoSource(video, index)
    video.muted = userMuted
  }

  // The user may have changed slides while this video was buffering.
  if (!ready || currentSlide !== index)
    return

  try {
    await waitForBufferedAhead(video, index, MOBILE_MIN_BUFFER_AHEAD)

    if (currentSlide !== index)
      return

    await video.play()
    hideVideoLoading(index)
    startVideoProgressWatchdog(video, index)

    if (!startedVideoIndexes.includes(index))
      startedVideoIndexes.push(index)

    scheduleNextVideoPreload(index, video)
  }
  catch (error) {
    hideVideoLoading(index)
    console.warn('3VE: reproducción bloqueada o no disponible', index, error)
  }
}

async function resumeVideoSafely(video, index) {
  if (!video || currentSlide !== index)
    return

  cancelVideoPreloadTimer()
  stopAllOtherVideoLoads(index)

  const hasSource = ensureVideoSource(video, index)
  if (!hasSource)
    return

  video.muted = userMuted

  if (video.readyState < HTMLMediaElement.HAVE_FUTURE_DATA)
    showVideoLoading(index)

  try {
    await waitForVideoEvent(
      video,
      'loadedmetadata',
      () => video.readyState >= HTMLMediaElement.HAVE_METADATA
    )

    const savedTime = savedVideoTimes[index]
    if (Number.isFinite(savedTime) && savedTime > 0) {
      // Restore the exact point where this slide was left.
      // If the source had to be reattached, seeking after loadedmetadata avoids
      // Safari/iOS ignoring currentTime assignments made too early.
      if (Math.abs(video.currentTime - savedTime) > 0.15)
        video.currentTime = savedTime
    }

    await waitForVideoEvent(
      video,
      'canplay',
      () => video.readyState >= HTMLMediaElement.HAVE_FUTURE_DATA
    )

    if (currentSlide !== index)
      return

    await waitForBufferedAhead(video, index, MOBILE_MIN_BUFFER_AHEAD)

    if (currentSlide !== index)
      return

    await video.play()
    hideVideoLoading(index)
    startVideoProgressWatchdog(video, index)

    if (!startedVideoIndexes.includes(index))
      startedVideoIndexes.push(index)

    scheduleNextVideoPreload(index, video)
  }
  catch (error) {
    hideVideoLoading(index)
    console.warn('3VE: no se pudo reanudar el vídeo', index, error)
  }
}

function unloadVideoSource(video, index) {
  if (!video)
    return

  // Preserve the logical playback position before releasing the network resource.
  if (Number.isFinite(video.currentTime) && video.currentTime > 0)
    savedVideoTimes[index] = video.currentTime

  video.pause()
  video.preload = 'none'

  // Removing src + load() aborts outstanding Range requests in browsers,
  // releasing bandwidth and decoder resources for the active slide.
  if (video.getAttribute('src')) {
    video.removeAttribute('src')
    video.load()
  }

  const loadedPos = loadedVideoIndexes.indexOf(index)
  if (loadedPos !== -1)
    loadedVideoIndexes.splice(loadedPos, 1)

  hideVideoLoading(index)
}

function stopAllOtherVideoLoads(activeIndex) {
  document.querySelectorAll('video[id^="video-"]').forEach(video => {
    const match = video.id.match(/^video-(\d+)$/)
    if (!match)
      return

    const index = Number(match[1])

    if (index !== activeIndex)
      unloadVideoSource(video, index)
  })
}

function cancelVideoPreloadTimer() {
  if (videoPreloadTimer) {
    clearTimeout(videoPreloadTimer)
    videoPreloadTimer = null
  }
}

function scheduleNextVideoPreload(index, currentVideo) {
  cancelVideoPreloadTimer()

  // On mobile the active video gets absolute network priority.
  // Do not start a second MP4 request in the background.
  if (isMobileVideoMode)
    return

  const checkStablePlayback = () => {
    // Do nothing if the visitor has already moved to another slide.
    if (currentSlide !== index || currentVideo.paused || currentVideo.ended)
      return

    // HAVE_FUTURE_DATA means the browser currently has enough decoded/buffered
    // information to keep moving. Only then do we spend bandwidth on the next video.
    if (currentVideo.readyState >= HTMLMediaElement.HAVE_FUTURE_DATA &&
        currentVideo.currentTime >= 2.5) {
      preloadNextVideo(index)
      videoPreloadTimer = null
      return
    }

    // If the connection is struggling, give the current video priority and retry later.
    videoPreloadTimer = setTimeout(checkStablePlayback, 1500)
  }

  // Give the active video roughly three seconds of exclusive bandwidth first.
  videoPreloadTimer = setTimeout(checkStablePlayback, 3000)
}

function preloadNextVideo(currentIndex) {
  if (isMobileVideoMode)
    return
  const slides = Array.from(document.querySelectorAll('.horizontal-scrolling'))

  for (let i = currentIndex + 1; i < slides.length; i++) {
    if (slides[i].dataset.video !== 'true')
      continue

    const nextVideo = document.getElementById(`video-${i}`)
    if (!nextVideo || !nextVideo.dataset.source)
      return

    // Keep network activity limited to: current video + exactly one next video.
    document.querySelectorAll('video[id^="video-"]').forEach(video => {
      const match = video.id.match(/^video-(\d+)$/)
      if (!match)
        return

      const videoIndex = Number(match[1])
      if (videoIndex !== currentIndex && videoIndex !== i)
        unloadVideoSource(video, videoIndex)
    })

    if (!nextVideo.getAttribute('src')) {
      nextVideo.muted = true
      nextVideo.playsInline = true
      nextVideo.preload = 'auto'
      nextVideo.src = nextVideo.dataset.source

      if (!loadedVideoIndexes.includes(i))
        loadedVideoIndexes.push(i)

      // preload="auto" is only a hint on mobile browsers, but load() gives the
      // browser the opportunity to start a Range request without playing it.
      nextVideo.load()
    }

    // Exactly one future video is considered.
    return
  }
}

function arrangeTagButtons() {
  const tagButtonContainers = document.querySelectorAll('.tag-btns-container-row-2')

  tagButtonContainers.forEach(container => {
    if (container.children.length === 4)
      container.classList.add('md-justify-center')
  })
}

function showImage(contentContainer, imageContainer, slideIndex) {
  const alreadyLoaded = loadedImageIndexes.includes(slideIndex)

  if (alreadyLoaded) {
    // Imagen ya disponible: el texto entra rápido, una vez asentado el cambio.
    showSlideInfo(slideIndex, 450)
  }
  else {
    const img = new Image()
    const imageUrl = imageContainer.dataset.sizedImage

    if (imageUrl)
      img.src = imageUrl
    else
      observeChangesToImageUrl(imageContainer, imageUrl => img.src = imageUrl)

    function onImageLoad() {
      imageContainer.style.backgroundImage = `url(${img.src})`
      imageContainer.style.backgroundSize = 'cover'
      imageContainer.style.opacity = 0

      requestAnimationFrame(() => {
        imageContainer.style.transition = 'opacity 0.6s ease'
        imageContainer.style.opacity = 1
      })

      loadedImageIndexes.push(slideIndex)

      // El texto aparece ligado a la carga real de la imagen, no a un
      // temporizador de 2 segundos iniciado antes de que la imagen estuviera lista.
      showSlideInfo(slideIndex, 500)
    }

    img.onload = onImageLoad
  }
}

const observeChangesToImageUrl = (imageContainer, action) => {
  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'data-sized-image') {
        const imageUrl = imageContainer.dataset.sizedImage
        action(imageUrl)
      }
    }
  })

  observer.observe(imageContainer, {
    attributes: true,                 // listen for attribute changes
    attributeFilter: ['data-sized-image'],  // only watch this specific attribute
  })
}

function showVolume(index, video) {
  const volume = document.getElementById('volume')
  volume.style.display = 'grid'

  showVolumeIcon(volume, userMuted)

  volumeListener = () => {
    userMuted = !userMuted
    localStorage.setItem('userMuted', userMuted)

    video.muted = userMuted
    if (!userMuted) video.play().catch(() => {})

    showVolumeIcon(volume, userMuted)
  }

  volume.addEventListener('click', volumeListener)
}

function removeVolumeListener() {
  const volume = document.getElementById('volume')
  volume.removeEventListener('click', volumeListener)
}

function showVolumeIcon(volume, muted) {
  const volumeIcon = volume.querySelector('i')

  if (muted) {
    volumeIcon.classList.add('fa-volume-xmark')
    volumeIcon.classList.remove('fa-volume-low')
  }
  else {
    volumeIcon.classList.add('fa-volume-low')
    volumeIcon.classList.remove('fa-volume-xmark')
  }
}

function hideSlideInfo(index) {
  if (index === undefined || index === null)
    return

  if (slideInfoTimers[index]) {
    clearTimeout(slideInfoTimers[index])
    delete slideInfoTimers[index]
  }

  document.getElementById(`info-container-${index}`)?.classList.add("container-hidden")
}

function showSlideInfo(index, requestedDelay = 650) {
  const slideIndex = index === undefined || index === null ? 0 : index

  if (slideInfoTimers[slideIndex])
    clearTimeout(slideInfoTimers[slideIndex])

  // Primera carga inmediata. El resto, como máximo 0,65 s por defecto.
  const delay = slideIndex === 0 ? 0 : Math.min(requestedDelay, 900)

  slideInfoTimers[slideIndex] = setTimeout(() => {
    if (currentSlide !== slideIndex) {
      delete slideInfoTimers[slideIndex]
      return
    }

    document.getElementById(`info-container-${slideIndex}`)?.classList.remove("container-hidden")
    delete slideInfoTimers[slideIndex]
  }, delay)
}

function disableScroll() {
  document.body.style.overflow = 'hidden'
}

function enableScroll() {
  document.body.style.overflow = ''
}

function showInfoSection() {
  const isMobile = window.innerWidth < 768

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible')
        observer.unobserve(entry.target) // only animate once
      }
    })
  },
  { rootMargin: `0px 0px ${isMobile ? '-200px' : '-400px'} 0px`})  // bottom margin shrunk by 400px - show elements when they are 400px in the screen


  document.querySelectorAll('.reveal').forEach(reveal => observer.observe(reveal))
}

function showScrollHint() {
  const lastSection = document.querySelector('.info-section.last')
  if (!lastSection) return

  let hint = document.getElementById('scroll-hint')
  if (!hint) {
    hint = document.createElement('div')
    hint.id = 'scroll-hint'
    hint.innerHTML = '<i class="fa-solid fa-chevron-down"></i>'
    document.body.appendChild(hint)
  }

  scrollHintObserver?.disconnect()

  hint.classList.remove('scroll-hint-hidden')

  scrollHintObserver = new IntersectionObserver((entries) => {
    hint.classList.toggle('scroll-hint-hidden', entries[0].isIntersecting)
  }, { threshold: 0.5 })

  scrollHintObserver.observe(lastSection)
}

function hideScrollHint() {
  document.getElementById('scroll-hint')?.classList.add('scroll-hint-hidden')
  scrollHintObserver?.disconnect()
  scrollHintObserver = null
}
